import { useEffect, type FC } from 'react'

import { Banner, BannerDescription } from '@wartek-id/banner'

import { useAPIGetNotificationList } from 'api/kinerja/useAPIKinerjaNotification'
import CardPanduan from 'app/KinerjaBerandaPage/components/CardPanduan'
import { CardUnreadNotification } from 'app/KinerjaBerandaPage/components/CardUnreadNotification'
import CardSurveyPendampinganPenilik from 'app/KinerjaBerandaPage/components/CardSurveyPendampinganPenilik'
import CardKinerjaSteps from 'app/KinerjaShared/components/CardKinerjaSteps'
import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import { useKinerjaPsTrackEvent } from 'app/KinerjaPSPage/hooks/useKinerjaPsTrackEvent'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import { BannerGantiPeriode } from 'app/KinerjaShared/components/BannerGantiPeriode'
import usePenetapanTahunanCountDinas from 'app/KinerjaDinasPage/hooks/usePenetapanTahunanCountDinas'
import CardPenetapanTahunan from 'app/KinerjaDinasPage/components/CardPenetapanTahunan'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import useToggleSdkContext from 'utils/useToogleSdk'
import usePelaksanaan from 'app/KinerjaPage/pages/PelaksanaanV2/hooks/usePelaksanaan'
import BannerNewAsn from 'app/KinerjaPage/pages/PelaksanaanV2/components/BannerNewAsn'
import CardPengKin2025 from 'app/KinerjaBerandaPage/components/CardPengKin2025'
import CardPenetapanTahunanPS from 'app/KinerjaPSPegawaiPage/components/CardPenetapanTahunanResult'
import { PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'

export interface KinerjaBerandaIndexProps {
  showBanner?: boolean
  prevRoute?: string
}

const KinerjaBerandaIndex: FC<KinerjaBerandaIndexProps> = ({
  showBanner = false,
  prevRoute,
}) => {
  const isNotifikasiEnabled =
    process.env.NEXT_PUBLIC_SKP_NOTIFIKASI_ENABLED === 'true'
  const { periodYear, periodNo } = usePeriodContext()

  const { data: dataNotificationList } = useAPIGetNotificationList({
    options: {
      useErrorBoundary: false,
      enabled: isNotifikasiEnabled,
      refetchOnMount: 'always',
    },
  })

  const unreadNotificationCount = dataNotificationList?.meta?.unread ?? 0

  const {
    isSuccess: isSuccessProfile,
    isPengawasSekolah,
    isKepalaDinas,
    isGuru,
    isKs,
    isPegawaiPengawasSekolah,
    isKepalaPkbmOrKb,
  } = useRoleContext()

  const { dataPelaksanaan } = usePelaksanaan(isGuru)

  const { trackOpenKinerjaBeranda } = useKinerjaPsTrackEvent()

  const {
    isWithinAllowedRange,

    // Count
    countAll,
    isAllSent,
  } = usePenetapanTahunanCountDinas()

  const toggleValue = useToggleSdkContext()

  useEffect(() => {
    if (isSuccessProfile && (isPengawasSekolah || isKepalaDinas)) {
      trackOpenKinerjaBeranda()
    }
  }, [
    isSuccessProfile,
    isPengawasSekolah,
    isKepalaDinas,
    trackOpenKinerjaBeranda,
  ])

  const isBlockNonAsnEnabled =
    toggleValue?.['kinerja-block-non-asn-period'] === true

  const isCardKinerja2025Enabled =
    toggleValue?.['kinerja-semakin-bermakna-2025-enabled'] === true &&
    (isKs || isGuru)

  const isNewAsn = dataPelaksanaan?.data?.newAsn === true

  if (isKepalaPkbmOrKb) {
    return (
      <div className="pl-64">
        <KinerjaSidebar sticky activeMenu="beranda" />
        <div className="flex flex-col w-full gap-6 p-6">
          <CardSurveyPendampinganPenilik />
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="pl-64">
        <KinerjaSidebar sticky activeMenu="beranda" />

        <div className="flex flex-col w-full gap-6 p-6">
          {isCardKinerja2025Enabled && <CardPengKin2025 />}
          {isBlockNonAsnEnabled && isNewAsn && isGuru && <BannerNewAsn />}
          {showBanner && (
            <Banner
              type="informational"
              title="Selamat datang di tampilan baru Beranda!"
              closable={false}
            >
              <BannerDescription>
                Kunjungi menu di samping untuk akses progres Pengelolaan Kinerja
                Anda.
              </BannerDescription>
            </Banner>
          )}

          {isNotifikasiEnabled && (
            <CardUnreadNotification
              count={unreadNotificationCount}
              prevRoute={prevRoute}
            />
          )}

          <BannerGantiPeriode />

          {isPegawaiPengawasSekolah && (
            <CardPenetapanTahunanPS
              year={periodYear}
              actionPath={PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH}
            />
          )}

          <CardPanduan />

          {/* Place on bottom if penetapan tahunan is actionable */}
          {isKepalaDinas &&
            isWithinAllowedRange &&
            countAll >= 1 &&
            !isAllSent &&
            periodNo === 2 && <CardPenetapanTahunan key={periodYear} />}

          <CardKinerjaSteps />
        </div>
      </div>
    </>
  )
}
export default KinerjaBerandaIndex
